import { createSelector } from 'reselect'

const selector = state => state.assignedOrdersReducer

export const assignedFilterSelector = createSelector(
  [selector],
  ({ filters }) => filters
)

export const assignedLoadMoreSelector = createSelector(
  [selector],
  ({ loadMore }) => loadMore
)

export const assignedLoadPageSelector = createSelector(
  [selector],
  ({ loadPage }) => loadPage
)

export const assignedErrorSelector = createSelector(
  [selector],
  ({ error }) => error
)

export const assignedLoadsSelector = createSelector(
  [selector],
  ({ orders }) => orders
)

export const assignedNoMoreSelector = createSelector(
  [selector],
  ({ noMore }) => noMore
)

export const assignedSelector = createSelector(
  [selector],
  assigned => assigned
)
